export default __webpack_public_path__ + "static/media/showcontrol_PC.232078a8.svg";